import StyledNavDropdown from "../StyledNavDropdown";
import { useTenantContext } from "../../../../../context/Tenant/TenantContext";
import DataCutterViewOptions from "./DataCutterViewOptions";
import InrixViewOptions from "./InrixViewOptions";

const ViewLayerSelect = () => {
  const { config } = useTenantContext();
  const isInrix = config.name === "Inrix";

  return (
    <StyledNavDropdown title={<span className="mr-2 text-white">View</span>}>
      {isInrix ?
        <InrixViewOptions />
      : <DataCutterViewOptions />}
    </StyledNavDropdown>
  );
};

export default ViewLayerSelect;
